var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_box_content finish"},[(_vm.errors.length > 0)?_c('h4',{staticClass:"text-negative"},[_vm._v("\n    "+_vm._s(_vm.errors[0].message)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }